module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/8b Loupana plec (flat iron steak 2).jpg";